import { Directive } from '@angular/core';

@Directive({
  selector: '[nzMentionSuggestion]',
  exportAs: 'nzMentionSuggestion'
})
export class NzMentionSuggestionDirective {}
